import { useEffect, useRef } from "react";
import { useUser } from "@clerk/clerk-react";
import { initAnalytics, identify, reset } from "../analytics";

// Renders nothing. Boots the analytics client once. identify() links the
// anonymous distinct id to the Clerk user id — it fires on sign-in and on
// every load while signed in (identify is idempotent). reset() on sign-out
// stops later anonymous activity on this browser (e.g. a guest on a shared
// device) from being attributed to the signed-out organizer.
function AnalyticsBootstrap() {
  const { user, isLoaded } = useUser();
  const userId = user?.id;
  const lastIdentified = useRef<string | null>(null);

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    if (!isLoaded) return;
    if (userId) {
      identify(userId);
      lastIdentified.current = userId;
    } else if (lastIdentified.current) {
      reset();
      lastIdentified.current = null;
    }
  }, [isLoaded, userId]);

  return null;
}

export default AnalyticsBootstrap;
